import { FC, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { MainLayout } from '../../layouts';
import { FullPageLoader } from '../../components';
import { RootState } from '../../stores/store';
import { NAV_ROUTES } from '../../constants/navRoutes';
import UserAuth from '../../services/auth';
import useNavigateToLogin from '@hooks/useNavigateToLogin';

const HomePage: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { navigateToLogin } = useNavigateToLogin();
  const appData = useSelector((state: RootState) => state?.AppData);

  const token = appData?.auth?.access_token || UserAuth.accessToken || '';

  // Hook to redirect valid user to auth or dashboard page
  useEffect(() => {
    if (token) {
      navigate({ pathname: NAV_ROUTES.DASHBOARD, search: location.search });
    } else {
      navigateToLogin();
    }
  }, [token]);

  return (
    <MainLayout>
      <FullPageLoader />
    </MainLayout>
  );
};

export default HomePage;
